module.exports = __webpack_public_path__ + "img/ciaz-2022.f66be032.svg";